module.exports = __webpack_public_path__ + "fonts/proximanova-bold-webfont.2fba96a6.woff";